// List no dependencies so this can be triggered ASAP
define([], function() {
  (function(document, window) {
      // User cannot hover at all, bail out
      if (window.matchMedia("(any-hover: none)").matches ||
          window.matchMedia("(hover: none)").matches)
          return;

      // If either of these match there's a possibility the
      // user can hover, but doesn't mean that they will.
      if (window.matchMedia("(any-hover: hover)").matches ||
          window.matchMedia("(hover: hover)").matches) {
          window.USER_CAN_HOVER = true;
      }

      //In case of IE 10 or IE 11 - we assume that hover is possible even though the media is not matching
      var ie11 = window.navigator.userAgent.indexOf('Trident/');
      var ie10 = window.navigator.userAgent.indexOf('MSIE ');

      if (ie11 > 0 || ie10 > 0) {
          window.USER_CAN_HOVER = true;
      }

      if (window.USER_CAN_HOVER) {
          document.querySelector('html').className += ' user-can-hover';
      }



  })(document, window);

  window.addEventListener('touchstart', function onFirstTouch() {
    window.USER_CAN_TOUCH = true;
    document.querySelector('html').className += ' user-can-touch';
    window.removeEventListener('touchstart', onFirstTouch, false);
  }, false);
});
